import { Component, OnInit, inject, signal } from '@angular/core';
import { User } from '@app/core/models/user.model';
import { AuthService } from '@app/core/services/auth.service';

@Component({
  selector: 'app-email-verification-banner',
  standalone: true,
  templateUrl: './email-verification-banner.html',
})
export class EmailVerificationBannerComponent implements OnInit {
  private readonly authService = inject(AuthService);

  readonly user = signal<User | null>(null);
  readonly dismissed = signal(false);
  readonly sending = signal(false);
  readonly message = signal<string | null>(null);

  ngOnInit(): void {
    this.authService.getUser().subscribe((user) => {
      this.user.set(user);
      this.dismissed.set(user ? this.authService.isEmailVerificationDismissed(user.id) : false);
    });
  }

  shouldShow(): boolean {
    const user = this.user();
    return Boolean(user?.can_access_product && !user.email_verified_at && !this.dismissed());
  }

  resend(): void {
    this.sending.set(true);
    this.message.set(null);
    this.authService.resendVerification().subscribe({
      next: () => {
        this.sending.set(false);
        this.message.set('Verification email sent.');
      },
      error: () => {
        this.sending.set(false);
        this.message.set('Could not send the email. Please try again.');
      },
    });
  }

  dismiss(): void {
    const user = this.user();
    if (user) {
      this.authService.dismissEmailVerification(user.id);
    }
    this.dismissed.set(true);
  }
}
